import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import endOfMonth from 'date-fns/end_of_month';
import addMonths from 'date-fns/add_months';
import { getUserAll } from './core/cacheService'
export default {
  namespaced: true,
  state: {
    mission:[],
    missionAll:[{id:''}],
    missionUser:{},
    inputSearch:'',
    loadingMissionList: false,
    missionTypes:[],
    selectShow:'',
    missionChart:[],
    missionChart6:[],
    missionEntry:0,
    countMissionAll:0,
    missionCustom:[],
    missionUncomplete:[],
    missionTypesIcon:[],
    company:[],
    missionperuser:[],
    missionComplete:[]
  },
  mutations: {
  setMission(state:any, result:any) {
      state.mission = result
  },
  setMissionCustom(state:any, result:any) {
    state.missionCustom = result
},
  setMissionAll(state:any, result:any) {
    state.missionAll = result
  },
  
  setMissionUser(state:any, result:any) {
    state.missionUser = result
  },
  setMissionChart(state:any, result:any) {
    state.missionChart = result
  },
  setMissionChart6(state:any, result:any) {
    state.missionChart6 = result
  },
  setinputSearch(state:any,value:any) {
    state.inputSearch = value.value
  },
  setloadingMissionList(state:any,result:any) {
    state.loadingMissionList = result
  },
  setMissionType(state:any,result:any) {
    state.missionTypes = result
  },
  setMissionTypeIcon(state:any,result:any) {
    state.missionTypesIcon = result
  },
  setselectShow(state: any, value: any) {
    state.selectShow = value.type
},
  setEntry(state: any, result: any) {
    state.missionEntry = result
  },
  setCountMissionAll(state: any, result: any) {
    state.countMissionAll = result
  },
  setMissionUncomplete(state: any, result: any) {
    state.missionUncomplete = result
  },
  setCompany(state: any, result: any) {
    state.company = result
  },
  setMissionPerUser(state: any, result: any) {
    //console.log("result",result)
    state.missionperuser = result
  },
  setMissionComplete(state: any, result: any) {
    state.missionComplete = result
  },
  },
  actions: {
    async getCompany({ state,commit, dispatch, rootState }: any){
      const company:  Array<any> = [];
      await  firebase.firestore().collection('houses').where("company","==",rootState.authen.user.company).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          if( company[doc.data().house]==undefined){
            company[doc.data().house]={name:doc.data().house_name}
          }
          });
        commit('setCompany', company)
        });
    },
    async getMisiionUser({ state,commit, dispatch, rootState }: any){
      const house=(await firebase.database().ref('houses').once('value')).val()
      const all_user=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild('company').equalTo(rootState.authen.user.company).once('value')).val()
      const missionUser:  Array<any> = [];
      const months16: Array<any> = [];
      const months6: Array<any> = [];
      const missionPerUser:  Array<any> = [];
      const dateNow = new Date()
      const yearnow = format(dateNow, 'YYYY')
      for(let x=0; x<16; x++){
        const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
        const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
        if(yearnow !== year){
            months16[enddate] = {
                month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                value:0
            }
        }else{
            months16[enddate] = { 
                month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                value:0
            }
        }
        if(x<6){
          if(yearnow !== year){
            months6[enddate] = {
                month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                value:0
            }
        }else{
            months6[enddate] = { 
                month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                value:0
            }
        }

        }
    }
      await  firebase.firestore().collection('mission_users').where("company","==",rootState.authen.user.company).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          const create_date = format(doc.data().create_date, 'YYYY-MM')
          if(months16[create_date]){
            months16[create_date].value+=1
          }
          if(months6[create_date]){
            months6[create_date].value+=1
          }
          if( missionUser[doc.data().mission_id]==undefined){
            missionUser[doc.data().mission_id]={count:1}
          }else {
            missionUser[doc.data().mission_id].count+=1
          }

          if(!missionPerUser[doc.data().mission_id]){
            missionPerUser[doc.data().mission_id]=[]
          }
          const house_name=house[doc.data().house]?house[doc.data().house].name:""
          const vote=doc.data().vote?doc.data().vote:0
          const emailKey=doc.data().create_user.replace(/\./g, "||");
          
          const pic=all_user[emailKey]&&all_user[emailKey].profilepic_crop?all_user[emailKey].profilepic_crop:""
          missionPerUser[doc.data().mission_id].push({create_user:doc.data().create_user,house_name:house_name,name:doc.data().create_name,points:vote,isWinner:'',pic:pic})

          
          });
         // console.log("missionPerUser",missionPerUser)
        commit('setMissionPerUser', missionPerUser)
        commit('setMissionUser', missionUser)
        commit('setMissionChart', months16)
        commit('setMissionChart6', months6)
        commit('setEntry', months16[format(dateNow, 'YYYY-MM')].value)
        });
    },
    async getMission({ state,commit, dispatch, rootState }: any){
      commit('setloadingMissionList', true)
      const missionsComplete: Array<any> = [];
      const _missionsComplete: Array<any> = [];
      
      const missionLive: Array<any> = [];
      
     
      await  firebase.firestore().collection('mission_complete').where("company","==",rootState.authen.user.company).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
         
            
            missionsComplete[doc.data().mission_id] = {id:doc.id,houses:doc.data().house[0],date:doc.data().createdate,winner_email:doc.data().winner_email,points:doc.data().points || {}}
            _missionsComplete.push({mission_id:doc.data().mission_id,houses:doc.data().house[0],date:doc.data().createdate})
          });
        });

      await  firebase.firestore().collection(`/mission_company/${rootState.authen.user.company}/mission`).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            
            if(doc.data().active){
              missionLive[doc.data().mission_id] = {id:doc.id,mission_id:doc.data().mission_id,active:doc.data().active}
            }
            if(doc.data().active==false){
              if(!missionsComplete[doc.data().mission_id]){
                missionsComplete[doc.data().mission_id] = {id:doc.id,houses:"",date:doc.data().createdate,winner_email:'',points:{}}
                _missionsComplete.push({mission_id:doc.data().mission_id,houses:"",date:doc.data().createdate})
              }
            }
            
            });
          });
      const missionSkip: { [key: string]: string } = {};
      await  firebase.firestore().collection('block_mission').where("company","==",rootState.authen.user.company).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          missionSkip[doc.data().mission_id] = doc.id
          });
        });
        firebase.firestore().collection('mission').get()
          .then(function (querySnapshot) {
            const missions: Array<any> = [];
            const missionCustom: Array<any> = [];
            querySnapshot.forEach((doc) => {
              const mission = doc.data()
              const house=(missionsComplete[doc.id])?missionsComplete[doc.id].houses:""
              mission.key = doc.id,
              mission.mission_id=doc.id,
              mission.description=mission.description_en,
              mission.name=mission.title_en
              mission.entries=!state.missionUser[doc.id]? 0:state.missionUser[doc.id].count,
              mission.winner= (missionsComplete[mission.key])?state.company[house]?state.company[house].name:"TBD":"TBD",
              mission.status= (missionsComplete[mission.key])?'completed':missionSkip[mission.key]?'skip':'upcoming'
              mission.customSet=mission.customSet===undefined?0:mission.customSet,
              mission.happilySet=mission.order===undefined?mission.happilySet:mission.order,
              mission.missionType=mission.type
              mission.missionTypeIcon=state.missionTypesIcon[mission.type]?state.missionTypesIcon[mission.type].icon:""
              if(mission.custom_order)
              {
                mission.status_order=mission.custom_order[rootState.authen.user.company]?true:false
                if(mission.custom_order[rootState.authen.user.company]){
                  mission.customSet=mission.custom_order[rootState.authen.user.company].customSet
                  mission.happilySet=mission.custom_order[rootState.authen.user.company].happilySet
                  missionCustom.push(mission)
                }
              }
              // if(mission.status!='completed'){
              //   console.log("ddd",mission.key)
              //   console.log("ddd===",mission.title_en)
              //   console.log("customSet===",mission.customSet)
              //   console.log("happilySet===",mission.happilySet)
              //    }
              // if(mission.title_en=='Produce an Album Cover') console.log("mission1",mission)
              // if(mission.title_en=='Produce an Album Cover') console.log("mission2",mission)
              if(mission.company===undefined){
                mission.type= "happily"
                missions.push(mission)
              }else if(mission.company===rootState.authen.user.company){
                mission.type= "custom"
                missions.push(mission)
                missionCustom.push(mission)
              }  
          });
          const order_missioncomplete = _.orderBy(_missionsComplete, function(dateObj) {
            return new Date(dateObj.date);
          },['asc'])
          const sort_List = _.sortBy(missions, ["happilySet", "customSet"]);
          const _missionCustom=_.filter(missionCustom,function (currentObject) {

            return (
              currentObject.status!='completed'&&(!missionLive[currentObject.mission_id])
            );
          }
        );
          const sort_missionCustom = _.sortBy(_missionCustom, ["happilySet", "customSet"]);
          const missionUncomplete=_.filter(sort_List,function (currentObject) {
              return (
                currentObject.status!='completed'
              );
            }
          );
          
          const _mission:  Array<any> = [];
          var Uncompleted=0
          let week=0
          //var live=true
          for(const i in order_missioncomplete){
            week++
            const _find=_.find(sort_List, function(o) { return o.mission_id == order_missioncomplete[i].mission_id; });
            if(_find){
              if(_find.status=="completed"){
                Uncompleted=0
              }else{
                Uncompleted=1
              }
              _mission.push({..._find,week:week,checkLive:missionLive[_find.mission_id]?true:false,Uncompleted:Uncompleted})
            }
          }
          
          
          const _sort_List = _.sortBy(missionUncomplete, ["happilySet", "customSet"]);
          for(const i in _sort_List){
            week++
            const _find=_.find(sort_List, function(o) { return o.mission_id == _sort_List[i].mission_id; });
            if(_find){
              if(_find.status=="completed"){
                Uncompleted=0
              }else{
                Uncompleted=1
              }
              _mission.push({..._find,week:week,checkLive:missionLive[_find.mission_id]?true:false,Uncompleted:Uncompleted})
            }
          }
          // sort_List.map((value,index)=>{
          //   var i=index-1>0?index-1:0
          //   var checkLive=false
          // // if(live){
          // //   if(sort_List[i].status=="completed"&&value.status=="upcoming"){
          // //     live=false
          // //     Uncompleted=1
          // //     checkLive=true
          // //   }else if(sort_List[i].status=="skip"&&value.status=="upcoming")
          // //   {
          // //     live=false
          // //     Uncompleted=1
          // //     checkLive=true
          // //   }
          // // }else{ 
          //   if(value.status=="completed"){
          //     Uncompleted=0
          //   }else{
          //     Uncompleted=1
          //   }
          // //}
          //   _mission.push({...value,week:index+1,checkLive:missionLive[value.mission_id]?true:false,Uncompleted:Uncompleted})
          // })
          const temp_mission= _.sortBy(_mission, ["Uncompleted"]);
          const _temp_mission:  Array<any> = [];
          temp_mission.map((value,index)=>{
            _temp_mission.push({...value,week:index+1})
          })
          //console.log("checkLive",_temp_mission)
          commit('setMissionAll', _temp_mission)
          commit('setCountMissionAll', _temp_mission.length)
          commit('setMission', _temp_mission)
          commit('setMissionCustom', sort_missionCustom)
          commit('setloadingMissionList', false)
          commit('setMissionComplete', missionsComplete)
          commit('setMissionUncomplete', missionUncomplete)
          if(state.inputSearch){
            dispatch('searchMission',state.inputSearch)
        }
        if (state.selectShow&&state.selectShow!=="show_all") {
          dispatch('selectStatus', state.selectShow)
      }
        });
    },
    async getMisiionType({ state,commit, dispatch, rootState }: any){
      const missionType: Array<any> = [];
      const _missionType:  Array<any> = [];
      await  firebase.firestore().collection('mission_type').get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          _missionType[doc.id]={icon:doc.data().icon_image}
          missionType.push({name:doc.data().name,key:doc.id})
          });
        commit('setMissionTypeIcon', _missionType)
        commit('setMissionType', missionType)
        });
    },
    searchMission({ commit, rootState, dispatch,state}:any,value:string){
   
      var re = new RegExp(value, 'gi')
      const missions = (state.selectShow) ? state.mission : state.missionAll
      if (value) {
          var response = _.filter(missions, (item): any => {
              if (item.name.match(re)) {
                  return true
              } else if (item.description.match(re)) {
                  return true
              } else if (item.winner.match(re)) {
                  return true
              }
          });
          // commit('setMissionSearch', response)
          
          commit('setMission', response)
      }else{
          dispatch('getMission', rootState.authen.user)
      }
  }, 
    selectStatus({ commit, rootState, dispatch, state }: any, value: string) {
      const missions = (state.inputSearch) ? state.mission : state.missionAll
      if(value=="only_show_completed"){
        // value="completed"
          var response = _.filter(missions, (item): any => {
            if (item.status.match("completed")) {
                return true
            }
        });
        commit('setMission', response)
      }else if(value=="only_show_upcoming"){
        var response = _.filter(missions, (item): any => {
          if (item.status.match("upcoming")) {
              return true
          }
      });
      commit('setMission', response)

      }
      else if (value == 'only_show_upcoming_and_skipped') {
          var response = _.filter(missions, (item): any => {
              if (item.status.match("upcoming")||item.status.match("skip")) {
                  return true
              }
          });
          commit('setMission', response)
      } else {
         commit("setMission",[])
          dispatch('getMission')
      }
  },
  async createMissionCustom({ commit, rootState, state ,dispatch}: any,data_val:any){

    const data=_.clone(data_val)
    var newId:string=""
    if(data.id){
       newId = data.id
    }else{
      newId =  firebase.firestore().collection('mission').doc().id
    }
    let _data={
      id:newId,
      title_th:data.names.th?data.names.th:data.names.en,
      title_en:data.names.en,
      titles:data.names,
      description_en:data.descriptions.en,
      description_th:data.descriptions.th?data.descriptions.th:data.descriptions.en,
      descriptions:data.descriptions,
      type:data.missionType,
      xp:parseInt(data.entryBonus),
      customSet:data.customSet,
      happilySet:data.happilySet,
      company:rootState.authen.user.company,
      createdate:format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
      updated:format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
    }
      //console.log(_data)
      if(data.status=="skip"){
        dispatch('blockMission',newId) 
      }
      await firebase.firestore().collection("mission").doc(newId).set(_data).then((docRef) => {
        /*save logs*/
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: newId,
          table: 'mission',
          status: 'create',
          user: rootState.authen.user.email
        }, {root:true})
        commit("setMission",[])
        dispatch('getMission')
        
    })
    },
  async updatePositionMissionCustom({ rootState, dispatch }: any,data:any){  
      if(data.type==="custom"){
      await firebase.firestore().collection("mission").doc(data.id).update({customSet:data.customSet,happilySet:data.happilySet}).then(()=>{
       /*save logs*/
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: data.id,
          table: 'mission',
          status: 'update',
          user: rootState.authen.user.email
        }, {root:true})
        // dispatch('getMission')
      })
    }else{
      let _data:any={}
      _data[`${rootState.authen.user.company}`]={customSet:data.customSet,happilySet:data.happilySet}
   
      await firebase.firestore().collection("mission").doc(data.id).update({custom_order:_data}).then(()=>{
        /*save logs*/
         dispatch('authen/addLogs', {
           company: rootState.authen.user.company,
           createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
           id: data.id,
           table: 'mission',
           status: 'update',
           user: rootState.authen.user.email
         }, {root:true})
         // dispatch('getMission')
       })
    }
},
  async deleteMissionCustom({ commit, rootState, state ,dispatch}: any,data:any){
      if(data.status=="skip"){
        dispatch('unblockMission',data.id) 
      }
     firebase.firestore().collection('mission').doc(data.id).delete().then(()=>{
             /*save logs*/
             dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
              createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              id: data.id,
              table: 'mission',
              status: 'delete',
              user: rootState.authen.user.email
            }, {root:true})
       
          dispatch('getMission') 
      })
      },
  blockMission({ commit, rootState, state, dispatch }: any, key: any) {
      firebase.firestore().collection('block_mission').where("company", "==", rootState.authen.user.company).where("mission_id", "==", key).get()
      .then(function (querySnapshot) {
          if(querySnapshot.empty){
            
              const block_mission: { [key: string]: string } = {};
              block_mission['mission_id'] = key
              block_mission['company'] = rootState.authen.user.company
              block_mission['email_updated'] = rootState.authen.user.email
              block_mission['createdate'] = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              firebase.firestore().collection('block_mission').add(block_mission).then((docRef) => {
                  /*save logs*/
                  const mission = state.mission;
                  for(const x in mission) {
                      if(mission[x].key === key) {
                          mission[x].block_id = docRef.id;
                          mission[x].status='skip'
                          break;
                      }
                  }
                  
                  commit('setMission', mission)
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                      createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                      id: docRef.id,
                      table: 'block_mission',
                      status: 'block',
                      user: rootState.authen.user.email
                  }, {root:true})
              });
          }else{
              dispatch('getMission',rootState.authen.user)
          }
      });
  },
  unblockMission({ commit, rootState, state, dispatch }: any, key: any) {
    firebase.firestore().collection('block_mission').where("company", "==", rootState.authen.user.company).where("mission_id", "==", key).get()
    .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
            firebase.firestore().collection('block_mission').doc(doc.id).delete().then(()=>{
                const mission = state.mission;
                for(const x in mission) {
                    if(mission[x].key === key) {
                        mission[x].block_id = '';
                        mission[x].status='upcoming'
                        break;
                    }
                }
                commit('setMission', mission)
            });
            /*save logs*/
            dispatch('authen/addLogs', {
              company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: key,
                table: 'block_mission',
                status: 'unblock',
                user: rootState.authen.user.email
            }, {root:true})
        });
    });
}
},
  getters: {
    mission : (state:any) => {
      
      return state.mission
  },
  missionCustom: (state:any) => {
    return state.missionCustom
  },
  inputSearch: (state:any) => {
    return state.inputSearch
  },
  loadingMissionList: (state:any) => {
    return state.loadingMissionList
  },
  missionTypeOpt: (state:any) => {
    return state.missionTypes
  },
  missionChart: (state:any) => {
    return state.missionChart
  },
  missionChart6: (state:any) => {
    return state.missionChart6
  },
  missionEntry: (state:any) => {
    return state.missionEntry
  },
  countMissionAll: (state:any) => {
    return state.countMissionAll
  },
  missionUncomplete: (state:any) => {
    return state.missionUncomplete
  },
  missionTypeIcon: (state:any) => {
    return state.missionTypesIcon
  },
  missionAll:  (state:any) => {
    return state.missionAll
  },
  missionperuser: (state:any) => {
    return state.missionperuser
  },
  missionComplete: (state:any) => {
    return state.missionComplete
  }
}
}
